import React, { useState } from 'react';
import { toast } from 'sonner';
import { Calendar } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { API } from '../utils/helpers';

const BirthdaySettings = () => {
  const { user } = useAuth();
  const [birthday, setBirthday] = useState(user?.birthday || '');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(!!user?.birthday);

  const saveBirthday = async () => {
    if (!birthday || birthday.length !== 5) { toast.error('Formato: MM-DD'); return; }
    setSaving(true);
    try {
      const res = await fetch(`${API}/user/birthday`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ birthday })
      });
      if (res.ok) { toast.success('Cumpleanos guardado'); setSaved(true); }
    } catch (e) { toast.error('Error'); }
    setSaving(false);
  };

  return (
    <div className="flex items-center gap-3 text-sm" data-testid="birthday-settings">
      <Calendar className="w-4 h-4 text-purple-400" />
      {saved ? (
        <span className="text-[var(--text-muted)]">
          Cumpleanos: {birthday || user?.birthday || 'No configurado'}
          <button onClick={() => setSaved(false)} className="ml-2 text-purple-400 underline text-xs">Cambiar</button>
        </span>
      ) : (
        <>
          <input 
            type="text" value={birthday}
            onChange={e => setBirthday(e.target.value)}
            placeholder="MM-DD"
            maxLength={5}
            className="mystic-input text-xs w-20 py-1 px-2"
            data-testid="birthday-input"
          />
          <button onClick={saveBirthday} disabled={saving} className="text-purple-400 text-xs underline" data-testid="save-birthday-btn">
            {saving ? 'Guardando...' : 'Guardar'}
          </button>
        </>
      )}
    </div>
  );
};

export default BirthdaySettings;
